import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const NAV_ITEMS = [
  { to: '/gmb-audit', label: '快速健診' },
  { to: '/gmb-audit/methodology', label: '方法說明' },
  { to: '/gmb-audit/consult', label: '預約諮詢' },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const isActive = (to: string) => (to === '/gmb-audit' ? pathname === to : pathname.startsWith(to));

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-300 bg-background-50/90 backdrop-blur">
      <div className="flex h-16 w-full items-center justify-between px-4 md:h-[72px] md:px-8">
        <Link to="/gmb-audit" className="flex cursor-pointer items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-700 text-background-50">
            <i className="ri-store-2-line text-xl" />
          </span>
          <span className="flex flex-col leading-tight">
            <span className="text-base font-bold tracking-wide text-foreground-950">天地人網</span>
            <span className="text-sm text-foreground-500">Google 商家快速健診</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`cursor-pointer rounded-md px-4 py-2.5 text-base font-medium transition-colors ${
                isActive(item.to)
                  ? 'bg-background-200 text-foreground-950'
                  : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-950'
              }`}
            >
              {item.label}
            </Link>
          ))}
          <Link
            to="/gmb-audit"
            className="ml-2 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-700 px-5 py-2.5 text-base font-semibold text-background-50 transition-colors hover:bg-primary-800"
          >
            <i className="ri-flashlight-line" />
            開始免費健診
          </Link>
        </nav>

        <button
          type="button"
          aria-label="開啟選單"
          onClick={() => setOpen((v) => !v)}
          className="flex h-11 w-11 cursor-pointer items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 md:hidden"
        >
          <i className={open ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'} />
        </button>
      </div>

      {open && (
        <div className="border-t border-background-300 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className={`cursor-pointer rounded-md px-4 py-3.5 text-base font-medium ${
                  isActive(item.to)
                    ? 'bg-background-200 text-foreground-950'
                    : 'text-foreground-600 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/gmb-audit"
              onClick={() => setOpen(false)}
              className="mt-1 inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-700 px-4 py-3.5 text-base font-semibold text-background-50"
            >
              <i className="ri-flashlight-line" />
              開始免費健診
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}